
import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import generatecertificateapi from '../api/generatecertificateapi';
import loginapi from '../api/login';
import { APISERVERURL } from '../APIServerURL';
import Course from '../components/ConvoGroupCard';
import { AiOutlineDownload } from "react-icons/ai";


import React from "react";

const StudentList = ({ students, onClick }) => {
  return (
    <div className="w-full p-4 space-y-4">
      {students.map((student, index) => (
        <div
          key={index}
          // 👇 Here we define custom column widths in fr
          className="grid grid-cols-1 md:grid-cols-[0.5fr_1fr_1.5fr_1fr_1fr_0.7fr_0.8fr_1fr_1fr_0.7fr_.5fr] 
                     border rounded-2xl shadow p-4 gap-4"
        >
          <div>
            <p className="text-sm text-gray-500">Sl No</p>
            <p>{index + 1}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Roll No:</p>
            <p>{student.rollno}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Name:</p>
            <p>{student.name}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Applied Name:</p>
            <p>{student.applied_name}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Assamese Name:</p>
            <p>{student.applied_assamiese_name}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Batch:</p>
            <p>{student.batch}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Type:</p>
            <p>{student.type}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Applied On:</p>
            <p>{new Date(student.applied_on).toLocaleDateString()}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Transaction No:</p>
            <p>{student.transaction_no}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Amount:</p>
            <p>₹{student.amount}</p>
          </div>

           <div>
            <div>
            <button className="px-4 rounded-lg border border-purple-600 text-purple-600 text-sm font-medium hover:bg-purple-50 transition min-w-[100px] bg-blue-200"
               onClick={() => onClick(student._id, "YES")}
            >

              BG</button>
          </div>
          <div>
              <button className="px-4 rounded-lg border border-purple-600 text-purple-600 text-sm font-medium hover:bg-purple-50 transition min-w-[100px] bg-gray-200 mt-2"
                 onClick={() => onClick(student._id, "NO")}>
                PLAIN</button>
          </div>
          </div>
        </div>
      ))}
    </div>
  );
};




function GenerateConvoCertificates({accessToken,setAccessToken,setRefreshFailed}) {
  const navigate = useNavigate();
  const [courses,setCourses]=useState([]);    
   const [slist,setSlist]=useState([]);   
  const [isAppLoaded,setIsAppLoaded]=useState(true);
  const [convocationNumber,setConvocationNumber]=useState('1'); 

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [view, setView] = useState("group");
  useEffect(()=>{
    
    //fetchAT();
  },[]);
  
  const fetchAT=async ()=>{
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await generatecertificateapi.post('/getConvocationCertificateAppliedStudents',{convocationNumber:convocationNumber,fromDate,toDate,view},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data.allbatches[0]));
        setCourses(response.data.allbatches); 
        setSlist(response.data.list); 
      
        setTimeout(() => {
          const mainElement = document.querySelector("main"); // Target <main> directly
          const scrollPosition = sessionStorage.getItem("scrollPosition");
  
          if (mainElement && scrollPosition) {
              mainElement.scrollTo(0, parseInt(scrollPosition, 10)); // Restore scroll position
              //console.log("Restored Scroll Position:", scrollPosition);
          }
      }, 100); // Delay for 100ms to ensure DOM is ready

        //alert(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await generatecertificateapi.post('/getConvocationCertificateAppliedStudents',{convocationNumber:convocationNumber,fromDate,toDate,view},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data));
                        setCourses(response.data.allbatches); 
                          setSlist(response.data.list); 
                        setTimeout(() => {
                          const mainElement = document.querySelector("main"); // Target <main> directly
                          const scrollPosition = sessionStorage.getItem("scrollPosition");
                  
                          if (mainElement && scrollPosition) {
                              mainElement.scrollTo(0, parseInt(scrollPosition, 10)); // Restore scroll position
                              //console.log("Restored Scroll Position:", scrollPosition);
                          }
                      }, 100); // Delay for 100ms to ensure DOM is ready
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }

  function downloadFile(fname)
    {
      fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
        response.blob().then((blob) => {         
            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);
                 
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fname;
            alink.click();
        });
      });
    }

 
  const handleDownloadCertificates = async (convocationNumber, batch, type, applied,bg,ids) => {
    try{
      
      const response= await generatecertificateapi.post('/downloadAllCertificatesOfATypeAndBatch',{convocationNumber, batch, type, applied,bg,ids},{headers:{'Authorization':`Bearer ${accessToken}`}});    
      alert(response.data);
      downloadFile(response.data);
    }
    catch(err)
    {
      if( err.response.status===403)
        {
          navigate(`/accessdenied`); 
        }
      try{
        const config = { withCredentials: true };
        const x=await loginapi.get('/getAccessToken',config);
        //alert(JSON.stringify(x['data']['accessToken']));
        
        const nat=x['data']['accessToken'];
        setAccessToken(nat);
        //console.log(`ne at ${nat}`);
        //console.log(`Second at:${accessToken}`);
        //alert('ok');
        try{       
          const response= await generatecertificateapi.post('/downloadAllCertificatesOfATypeAndBatch',{convocationNumber, batch, type, applied,bg,ids},{headers:{'Authorization':`Bearer ${nat}`}});    
          alert(JSON.stringify(response.data));
          downloadFile(response.data);
         }
         catch(err)
         {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          alert('unusual error newposts.js');
          //setIsAppLoaded(true);
          //alert(JSON.stringify(err));
          //navigate('/');
         }
      }
      catch(err)
      {
        alert(JSON.stringify(err));
        //setIsAppLoaded(true);
        //setError(JSON.stringify(err));
        //navigate('/');
      }
 
    }
  };


  const handleDownloadCSVReport=async ()=>{
    try{
        const response= await generatecertificateapi.post('/downloadAllCertificatesCsvData',{convocationNumber,fromDate,toDate},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        alert(response.data);
          downloadFile(response.data);
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          //alert(JSON.stringify(x['data']['accessToken']));
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          
          setRefreshFailed(false);  
          //console.log(`ne at ${nat}`);
          //console.log(`Second at:${accessToken}`);
          //alert('ok');
          try{       
            const response= await generatecertificateapi.post('/downloadAllCertificatesCsvData',{convocationNumber,fromDate,toDate},{headers:{'Authorization':`Bearer ${nat}`}});    
            alert(response.data);
          downloadFile(response.data);
           }
           catch(err)
           {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
              
              setRefreshFailed(true);  
            alert('unusual error newposts.js');
            //setIsAppLoaded(true);
            //alert(JSON.stringify(err));
            //navigate('/');
           }
        }
        catch(err)
        {
          alert(JSON.stringify(err));
          
          setRefreshFailed(true);  
          //setIsAppLoaded(true);
          //setError(JSON.stringify(err));
          //navigate('/');
        }
      }
      finally{
      }
  }


    const handleDownloadCompleteCSVReport=async ()=>{
    try{
        const response= await generatecertificateapi.post('/downloadCompleteCertificatesCsvData',{convocationNumber},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        alert(response.data);
          downloadFile(response.data);
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          //alert(JSON.stringify(x['data']['accessToken']));
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          
          setRefreshFailed(false);  
          //console.log(`ne at ${nat}`);
          //console.log(`Second at:${accessToken}`);
          //alert('ok');
          try{       
            const response= await generatecertificateapi.post('/downloadCompleteCertificatesCsvData',{convocationNumber},{headers:{'Authorization':`Bearer ${nat}`}});    
            alert(response.data);
          downloadFile(response.data);
           }
           catch(err)
           {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
              
              setRefreshFailed(true);  
            alert('unusual error newposts.js');
            //setIsAppLoaded(true);
            //alert(JSON.stringify(err));
            //navigate('/');
           }
        }
        catch(err)
        {
          alert(JSON.stringify(err));
          
          setRefreshFailed(true);  
          //setIsAppLoaded(true);
          //setError(JSON.stringify(err));
          //navigate('/');
        }
      }
      finally{
      }
  }

  const handleGoClick = async () => {
    //alert("From:"+fromDate+ "To:"+ toDate);
    // you can call your API or any handler here
    //if(view==='group')
     await fetchAT();
  };

   const onStudentDownload=async (id,bg)=>{
      try{
      
      const response= await generatecertificateapi.post('/downloadSingleCertificate',{id,bg},{headers:{'Authorization':`Bearer ${accessToken}`}});    
      alert(response.data);
      downloadFile(response.data);
    }
    catch(err)
    {
      if( err.response.status===403)
        {
          navigate(`/accessdenied`); 
        }
      try{
        const config = { withCredentials: true };
        const x=await loginapi.get('/getAccessToken',config);
        //alert(JSON.stringify(x['data']['accessToken']));
        
        const nat=x['data']['accessToken'];
        setAccessToken(nat);
        //console.log(`ne at ${nat}`);
        //console.log(`Second at:${accessToken}`);
        //alert('ok');
        try{       
          const response= await generatecertificateapi.post('/downloadSingleCertificate',{id,bg},{headers:{'Authorization':`Bearer ${nat}`}});    
          alert(JSON.stringify(response.data));
          downloadFile(response.data);
         }
         catch(err)
         {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          alert('unusual error newposts.js');
          //setIsAppLoaded(true);
          //alert(JSON.stringify(err));
          //navigate('/');
         }
      }
      catch(err)
      {
        alert(JSON.stringify(err));
        //setIsAppLoaded(true);
        //setError(JSON.stringify(err));
        //navigate('/');
      }
 
    }
    }
  
    return (
      <main>
        <div className="flex flex-col items-center">
          <div className="text-center mb-4">
            <h1 className="text-2xl font-bold text-gray-800 ">GENERATE CONVOCATION CERTIFICATES</h1>
          </div>
          <div className="flex items-center gap-4">
      {/* From Date */}
      <div className="flex flex-col">
        <label className="text-sm font-medium mb-1">From</label>
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          className="border rounded-lg px-3 py-2"
        />
      </div>

      {/* To Date */}
      <div className="flex flex-col">
        <label className="text-sm font-medium mb-1">To</label>
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          className="border rounded-lg px-3 py-2"
        />
      </div>

 <div className="flex flex-col">
        <label className="text-sm font-medium mb-1 text-transparent">To</label>
         <button
        onClick={handleGoClick}
        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
      >
        Go
      </button>
      </div>
      {/* Go Button */}
     
    </div>
          <div>
                                   {false && <button 
                                     onClick={handleDownloadCSVReport}
                                      className="flex items-center text-xs gap-2 bg-purple-800 text-white px-2 py-1 rounded-lg hover:bg-purple-900 transition duration-200"
                                    >
                                      <AiOutlineDownload size={20} />
                                      Download CSV data
                                    </button>}
          </div>

          <div className="w-full flex justify-center items-center bg-green-200 p-2 rounded gap-5 mt-2">
      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          checked={view === "group"}
          onChange={() => setView("group")}
          className="w-6 h-6 transform scale-125 accent-green-600"
        />
        Group View
      </label>

      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          checked={view === "list"}
          onChange={() => setView("list")}
          className="w-6 h-6 accent-green-600"
        />
        List View
      </label>

     <button 
                                     onClick={handleDownloadCSVReport}
                                      className="flex items-center text-xs gap-2 bg-purple-800 text-white px-2 py-1 rounded-lg hover:bg-purple-900 transition duration-200"
                                    >
                                      <AiOutlineDownload size={20} />
                                      Download selected CSV data
                                    </button>

                                         <button 
                                     onClick={handleDownloadCompleteCSVReport}
                                      className="flex items-center text-xs gap-2 bg-blue-700 text-white px-2 py-1 rounded-lg hover:bg-purple-900 transition duration-200"
                                    >
                                      <AiOutlineDownload size={20} />
                                      Download all CSV data
                                    </button>
                                    
    </div>
          {view==='group' && (<div className="flex flex-wrap justify-center gap-4 mt-9">
          {isAppLoaded ? (
            courses.length > 0 ? (
              courses.map((course) => (
                <Course key={course.batch} course={course} convocationNumber={convocationNumber} handleDownloadCertificates={handleDownloadCertificates}/>
              ))
            ) : (
              <p>No batches available.</p>
            )
          ) : (
            <p>Please wait...</p>
          )}
          </div>)}
          {view==='list' && (<div className="flex flex-wrap justify-center gap-4 mt-9">
          {isAppLoaded ? (
            StudentList.length > 0 ? (
             <StudentList students={slist} onClick={onStudentDownload}/>
            ) : (
              <p>No students available.</p>
            )
          ) : (
            <p>Please wait...</p>
          )}
          </div>)}
        </div>

     
      </main>
    )
  }
  
  export default GenerateConvoCertificates